export const environment = {
  production: false,
  LogInAPIEndpoint: 'https://revdxapi.apeasycloud.com',
  APIEndpoint: 'https://revdxapi.apeasycloud.com/api',
  // LogInAPIEndpoint: 'https://omniaqa.apeasycloud.com',
  // APIEndpoint: 'https://omniaqa.apeasycloud.com/api',

  PowerBi_GroupId: '61b50174-abb4-4252-952c-55b455803415',
  Revenue_ReportId: 'f9fdad07-7206-46be-b0c6-d9bb4dac9a29'
};
